export default __webpack_public_path__ + "static/media/check.9c298300.svg";